<template>
    <div class="need">
        <h2>定制需求</h2>
        <form action="https://guanwang.wsandos.com/home/index/getNeed" method="post" target="submitFrame">
            <div class="needtext">
                <span>{{count}}/20</span>
                <input type="text" placeholder="一句话描述您的需求，例如：房地产销售" @input="valLength" ref="needinput" name="demand">
            </div>
            <div class="phonetext">
                <input type="text" placeholder="请输入您的手机号码" @change="checkPhone" ref="phoneinput" name="phone">
            <button @click="send">发送</button>
            </div>
        </form>
        <iframe  id="submitFrame" style="display: none;width:0; height:0" name="submitFrame"  src="about:blank"></iframe>
    </div>
</template>

<script>
export default {
    name: "Need",
    data () {
        return {
            count: 0,
            phone: false
        }
    },
    methods: {
        valLength () {
            const needStr = this.$refs.needinput.value
            this.$refs.needinput.value = needStr.replace(/\s{2,}/g,' ')
            this.count = needStr.replace(/\s{1,}/g,'').length
            if( this.count > 20 ){
                this.count = 20
                this.$refs.needinput.value = needStr.substr( 0 , needStr.length - 1 )
            }
        },
        checkPhone () { 
            var phone = this.$refs.phoneinput.value;
            if(!(/^1[3456789]\d{9}$/.test(phone))){ 
                this.phone = false;
            }else{
                this.phone = true;
            }
        },
        send () {
            if(this.$refs.needinput.value.replace(/\s{1,}/g,'') ==''){
                alert("请填写内容！")
                event.preventDefault()
                return false
            }
            if(this.$refs.needinput.value.replace(/\s{1,}/g,'').length > 20){
                alert("超出20个字数限制！")
                event.preventDefault()
                this.$refs.needinput.value = ""
                this.count = 0
                return false
            }
            if(!this.phone){
                alert("手机号码有误，请重填");
                event.preventDefault()
                this.$refs.phoneinput.value = ""
                return false
            }
            alert("提交成功")
            this.count = 0
            setTimeout(()=>{
                this.$refs.needinput.value = ""
                this.$refs.phoneinput.value = ""
            },20)
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
     .need
        padding: 10.6% 3.3% 7.2%
        text-align: center
        background-image: url("../../static/images/m_home_need.png")
        background-size: cover
        h2
            position: relative
            display:inline-block
            margin: 0 auto
            color: #fff
            font-size: 0.4rem
            font-weight: 1000
            letter-spacing: 1px
            &:after
                position: absolute
                display: block
                content: ''
                bottom: 0
                right: -0.14rem
                width: 0.34rem
                height: 0.08rem
                background: $yellow
                border-radius: 0.05em
                opacity: 0.8
        form
            position: relative
            margin-top: 3em
            font-size: 0.3rem
            text-align: left
            input
                color: $black
                text-indent: 0.8em
                outline: none
                border: none
                border-radius: 0 !important
                line-height: 3em
            .needtext
                width: 100%
                margin-bottom: 3%
                input
                    width: 85%
                span
                    float: right
                    vertical-align: middle
                    text-align: center
                    width: 15%
                    line-height: 3em
                    padding: 0 
                    color: #999
                    background: #fff
            .phonetext
                width: 100%
                background: #fff
                input
                    width: 68%
                button
                    padding: 0.3em 2em
                    background: $yellow
                    vertical-align: middle
                    margin-left: 0.8em
                    color: $black
                    font-weight: 1000
                    outline: none
                    border: none
</style>


// WEBPACK FOOTER //
// src/components/mobile/HomeNeed.vue